/**
 * Лінивий чанк банера легкого режиму (UX-36): завантаження і стан «чанк уже на сторінці». Банер
 * малюється лише разом з екраном (lite-mode.md, розд. 2), тож `LiteOfferGate` питає, чи чанк
 * приїхав раніше за кадр екрана, а не чекає на нього (`GlobalBanners.tsx`).
 */
import type { ComponentType } from 'react';
import type { LiteReason } from '../prefs/lite-offer.ts';

type Banner = ComponentType<{ reason: LiteReason }>;

let banner: Banner | null = null;
let loading: Promise<void> | null = null;

/** Компонент банера, якщо чанк уже завантажено; інакше `null`. */
export const liteBanner = (): Banner | null => banner;

/** Почати вантажити чанк (один раз); помилка не страшна: банера просто не буде. */
export function loadLiteBanner(): Promise<void> {
  loading ??= import('./LiteOfferBanner.tsx').then(
    (m) => {
      banner = m.default;
    },
    () => {
      loading = null;
    },
  );
  return loading;
}

/** Тести: чанк знову «не завантажено». */
export function resetLiteBanner(): void {
  banner = null;
  loading = null;
}
